/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useMemo} from 'react'
import {Link, useNavigate} from 'react-router-dom'

import clsx from 'clsx'
import moment from 'moment'
import {useSelector} from 'react-redux'
import useApi from '../../../../../../hooks/useQuery'
import {GET_BUSINESS_DETAIL_BY_ID} from '../../../GraphQLQueries/Doctor'
import {GET_MY_PROFILE} from '../../../../../common/GraphQLQuries/common'
import {LoadingSpinner} from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import {getInitials} from '../../../../../../data/config'
import {GET_DASHBOARD_COUNT_TOP_V1} from '../../../../PharmaModule/GraphQLQueries/querys'

type Props = {
  className: string
}

type PharmaDashboardData = {
  medicineInStock: number
  expirySoon: number
  orderRestock: number
  registeredUser: number
  registeredVendor: number
  totalMonthlyOrder: number
  registeredDoctor: number
  doctorSaleOrder: number
  expiredMedicine: number
  doctorSaleOrderCreated: number
  doctorSaleOrderCompleted: number
  totalSaleOrder: number
  stockAmount: number
  totalSaleOrderCompleted: number
  totalSaleOrderReturned: number
  topSellingMedicines: []
  saleOrderRevenue: number
}

type WeekDayData = {
  day: string
  date: string // DD/MM/YYYY
  rxCount: number
  appointmentCount: number
  __typename: 'weekData'
}

const dateFormateOptions: Intl.DateTimeFormatOptions = {
  weekday: 'short', // "Tue"
  day: '2-digit', // "02"
  month: 'short', // "Sep"
  year: 'numeric', // "2025"
}

const TIME_PERIODS_OPTIONS = ['Daily', 'Weekly', 'Monthly']

const PharmaDetails: React.FC<Props> = ({className}) => {
  const [businessData, setbusinessData] = useState<any>({})
  const [userDataObj, setUserData] = useState<any>({})
  const navigate = useNavigate()
  const reduxData: any = useSelector((state) => {
    return state
  })

  const [selectedDateValue, setSelectedDateValue] = useState<Date>(new Date())
  const [selectedPeriod, setSelectedPeriod] = useState('Daily')
  const [selectedMonthForWeekly, setSelectedMonthForWeekly] = useState<string>(
    moment().format('YYYY-MM')
  )
  const [selectedWeek, setSelectedWeek] = useState<string>('week1')
  const [selectedMonthForMonthly, setSelectedMonthForMonthly] = useState<string>(
    moment().format('YYYY-MM')
  )

  const [activeTab, setActiveTab] = useState('details')
  const [pharmaInsights, setPharmaInsights] = useState<PharmaDashboardData | undefined>()
  const [heading, SetHeading] = useState(new Date().toLocaleDateString('en-US', dateFormateOptions))

  const generateMonthOptions = (count: number = 6) => {
    const months = []
    let current = moment()
    for (let i = 0; i < count; i++) {
      months.push(
        <option key={current.format('YYYY-MM')} value={current.format('YYYY-MM')}>
          {current.format('MMM YYYY')}
        </option>
      )
      current = current.subtract(1, 'month')
    }
    return months
  }

  const generateWeekOptions = (yearMonth: string) => {
    const startOfMonth = moment(yearMonth).startOf('month')
    const endOfMonth = moment(yearMonth).endOf('month')
    const weeks = []
    let weekNumber = 1
    let currentWeekStart = startOfMonth.clone().startOf('isoWeek')

    while (currentWeekStart.isSameOrBefore(endOfMonth) && weekNumber <= 6) {
      const weekEnd = currentWeekStart.clone().endOf('isoWeek')
      const displayRange = `${currentWeekStart.format('MMM DD')} - ${weekEnd.format('MMM DD')}`

      weeks.push({
        value: `week${weekNumber}`,
        label: `Week ${weekNumber}`,
        displayRange: displayRange,
        startDate: currentWeekStart.toDate(),
        endDate: weekEnd.toDate(),
      })
      currentWeekStart = currentWeekStart.add(1, 'week')
      weekNumber++
    }
    return weeks
  }

  const {startDate, endDate, monthParam, yearParam} = useMemo(() => {
    let calculatedStartDate: Date | null = null
    let calculatedEndDate: Date | null = null
    let calculatedMonthParam: number | null = null
    let calculatedYearParam: number | null = null

    if (selectedPeriod === 'Daily') {
      calculatedStartDate = moment(selectedDateValue).startOf('day').toDate()
      calculatedEndDate = moment(selectedDateValue).endOf('day').toDate()
      calculatedMonthParam = moment(selectedDateValue).month() + 1
      calculatedYearParam = moment(selectedDateValue).year()
    } else if (selectedPeriod === 'Weekly') {
      const selectedMonthMoment = moment(selectedMonthForWeekly)
      calculatedMonthParam = selectedMonthMoment.month() + 1
      calculatedYearParam = selectedMonthMoment.year()

      const weekOptions = generateWeekOptions(selectedMonthForWeekly)
      const currentWeekData = weekOptions.find((w) => w.value === selectedWeek)

      if (currentWeekData) {
        calculatedStartDate = currentWeekData.startDate
        calculatedEndDate = currentWeekData.endDate
      } else if (weekOptions.length > 0) {
        calculatedStartDate = weekOptions[0].startDate
        calculatedEndDate = weekOptions[0].endDate
        setSelectedWeek(weekOptions[0].value)
      } else {
        calculatedStartDate = selectedMonthMoment.clone().startOf('month').toDate()
        calculatedEndDate = selectedMonthMoment.clone().endOf('month').toDate()
      }
    } else if (selectedPeriod === 'Monthly') {
      const selectedMonthMoment = moment(selectedMonthForMonthly)
      calculatedStartDate = selectedMonthMoment.startOf('month').toDate()
      calculatedEndDate = selectedMonthMoment.endOf('month').toDate()
      calculatedMonthParam = selectedMonthMoment.month() + 1
      calculatedYearParam = selectedMonthMoment.year()
    }

    if (!calculatedStartDate || !calculatedEndDate) {
      calculatedStartDate = moment().startOf('day').toDate()
      calculatedEndDate = moment().endOf('day').toDate()
      calculatedMonthParam = moment().month() + 1
      calculatedYearParam = moment().year()
    }

    return {
      startDate: calculatedStartDate,
      endDate: calculatedEndDate,
      monthParam: calculatedMonthParam,
      yearParam: calculatedYearParam,
    }
  }, [
    selectedPeriod,
    selectedDateValue,
    selectedMonthForWeekly,
    selectedWeek,
    selectedMonthForMonthly,
  ])

  // const {
  //   data: monthlyReportData,
  //   loading: monthlyReportLoading,
  //   refetch: monthyReportRefetch,
  // } = useApi(false, GET_DASHBOARD_COUNT_TOP_V1, {
  //   startDate: startDate,
  //   endDate: endDate,
  // })

  const {
    data: dashboardData,
    loading: dashboardLoading,

    refetch: dashboardDataRefetch,
  } = useApi(false, GET_DASHBOARD_COUNT_TOP_V1, {
    startDate: startDate?.toISOString(),
    endDate: endDate?.toISOString(),
  })

  useEffect(() => {
    if (activeTab === 'insight' && monthParam && yearParam) {
      dashboardDataRefetch()
    }
  }, [activeTab, monthParam, yearParam, dashboardDataRefetch, selectedDateValue])

  useEffect(() => {
    if (activeTab === 'insight' && startDate && endDate) {
      dashboardDataRefetch()
    }
  }, [activeTab, startDate, endDate, dashboardDataRefetch])

  useEffect(() => {
    if (dashboardData) {
      console.log('dashboardData', dashboardData)
      console.log('dashboardData?.data', dashboardData?.data)
      console.log('dashboardData?.data?.getDashboardCountsV1', dashboardData?.getDashboardCountsV1)
      setPharmaInsights(dashboardData?.getDashboardCountsV1)
    }
  }, [dashboardData])

  // useEffect(() => {
  //   if (monthlyReportData) {
  //     let currentRxCount = 0
  //     let currentAppointmentCount = 0

  //     if (
  //       monthlyReportData.getClinicRXMonthlyReport &&
  //       Array.isArray(monthlyReportData.getClinicRXMonthlyReport)
  //     ) {
  //       if (selectedPeriod === 'Weekly' && selectedWeek) {
  //         const selectedWeekData = monthlyReportData.getClinicRXMonthlyReport.find(
  //           (report: any) => report.title.toLowerCase() === selectedWeek.replace('week', 'week ')
  //         )
  //         if (selectedWeekData) {
  //           currentRxCount = selectedWeekData.totalRx
  //           currentAppointmentCount = selectedWeekData.totalAppointment
  //         }
  //       } else if (selectedPeriod === 'Daily') {
  //         const todayStr = selectedDateValue.toLocaleDateString('en-GB').split('/').join('/')

  //         for (const week of monthlyReportData.getClinicRXMonthlyReport) {
  //           const found = week.weekWiseData.find((item: any) => item.date === todayStr)
  //           if (found) {
  //             // console.log("Found today's data:", found);
  //             currentRxCount = found.rxCount
  //             currentAppointmentCount = found.appointmentCount
  //           }
  //         }
  //       } else {
  //         monthlyReportData.getClinicRXMonthlyReport.forEach((report: any) => {
  //           currentRxCount += report.totalRx
  //           currentAppointmentCount += report.totalAppointment
  //         })
  //       }
  //     }

  //     setTotalRxCount(currentRxCount)
  //     setTotalAppointmentCount(currentAppointmentCount)
  //   }
  // }, [selectedDateValue, selectedPeriod, selectedWeek])

  const {data: businessDetailData, loading: businessDetailLoading} = useApi(
    true,
    GET_BUSINESS_DETAIL_BY_ID,
    {}
  )
  useEffect(() => {
    if (businessDetailData) {
      setbusinessData(businessDetailData?.getBusinessDetails)
    }
  }, [businessDetailData])

  const {data: userData, loading: userLoading} = useApi(true, GET_MY_PROFILE, {})
  useEffect(() => {
    if (userData) {
      setUserData(userData?.getMyUserProfile)
    }
  }, [userData])

  useEffect(() => {
    let newHeading = ''
    if (selectedPeriod === 'Daily') {
      newHeading = selectedDateValue.toLocaleDateString('en-US', dateFormateOptions)
    } else if (selectedPeriod === 'Weekly') {
      if (selectedWeek) {
        const currentWeekData = generateWeekOptions(selectedMonthForWeekly).find(
          (w) => w.value === selectedWeek
        )
        if (currentWeekData) {
          newHeading = `${currentWeekData.displayRange}, ${moment(selectedMonthForWeekly).format(
            'YYYY'
          )}`
        } else {
          newHeading = `Select Week, ${moment(selectedMonthForWeekly).format('MMM YYYY')}`
        }
      } else if (selectedMonthForWeekly) {
        newHeading = `Select Week, ${moment(selectedMonthForWeekly).format('MMM YYYY')}`
      } else {
        newHeading = `Weekly View`
      }
    } else if (selectedPeriod === 'Monthly') {
      if (selectedMonthForMonthly) {
        newHeading = moment(selectedMonthForMonthly).format('MMM YYYY')
      } else {
        newHeading = `Monthly View`
      }
    }
    SetHeading(newHeading)
  }, [
    selectedPeriod,
    selectedDateValue,
    selectedMonthForWeekly,
    selectedWeek,
    selectedMonthForMonthly,
    startDate,
    endDate,
  ])

  const handlePeriodChange = (period: string) => {
    setSelectedPeriod(period)

    setSelectedWeek(period === 'Weekly' ? 'week1' : '')
    setSelectedMonthForWeekly(moment().format('YYYY-MM'))
    setSelectedMonthForMonthly(moment().format('YYYY-MM'))
    setSelectedDateValue(new Date())
  }

  const handleMonthForWeeklyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMonthForWeekly(e.target.value)
    setSelectedWeek('week1')
  }

  const handleWeekChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedWeek(e.target.value)
  }

  const handleMonthForMonthlyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedMonthForMonthly(e.target.value)
  }

  const overallLoading =
    businessDetailLoading || userLoading || dashboardLoading || dashboardLoading

  return (
    <div className={`card ${className}`}>
      <LoadingSpinner isLoading={overallLoading} />
      <div className='px-8 border-0 mt-4'>
        <div className='d-flex flex-direcion-row justify-content-between col-12 align-items-center my-2'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-normal fs-3 mb-1 me-3'>
              Business Name-{' '}
              <span className='fw-bold'>{`${businessData?.businessProfile?.businessName}`}</span>
            </span>

            <button
              className={
                activeTab === 'insight'
                  ? clsx('ePulse-btn-secondory me-4')
                  : 'ePulse-btn-selected-white text-dark me-4'
              }
              onClick={() => {
                setActiveTab((value) => (value === 'details' ? 'insight' : 'details'))
              }}
            >
              <span className='fs-6 '>{activeTab === 'insight' ? 'Details' : 'Insight'}</span>
            </button>
          </h3>

          {activeTab === 'insight' && (
            <div className='dropdown me-3'>
              <button
                className='btn btn-secondary dropdown-toggle'
                type='button'
                id='mainPeriodDropdown'
                data-bs-toggle='dropdown'
                aria-expanded='false'
              >
                {selectedPeriod}
              </button>
              <ul className='dropdown-menu' aria-labelledby='mainPeriodDropdown'>
                {TIME_PERIODS_OPTIONS.map((option) => (
                  <li key={option}>
                    <button className='dropdown-item' onClick={() => handlePeriodChange(option)}>
                      {option}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
        <div className='separator mx-2' />
      </div>

      {activeTab === 'details' && (
        <div className='d-flex flex-column'>
          <div className='d-flex flex-direcion-row card-header border-0 justify-content-between '>
            <div className=' bg-light my-6 col p-2'>
              <div className='d-flex flex-direction-row'>
                {reduxData?.auth?.profileData?.profilePhoto ? (
                  <img
                    src={reduxData?.auth?.profileData?.profilePhoto}
                    alt=''
                    className='rounded-circle'
                    width={80}
                    height={80}
                  />
                ) : (
                  <div
                    className='border border-1 border-dark bg-light rounded-circle text-center d-flex justify-content-center align-items-center'
                    style={{height: '70px', width: '70px'}}
                  >
                    <span className='fs-1 fw-bold'>
                      {getInitials(
                        `${businessData?.userProfile?.firstName} ${businessData?.userProfile?.lastName}`
                      )}
                    </span>
                  </div>
                )}

                <div className='d-flex flex-wrap mx-5 flex-column'>
                  <span className='fs-6 '>
                    Associated Name-{' '}
                    <span className='fw-bold'>
                      {' '}
                      {`${userDataObj?.userProfile?.firstName} ${userDataObj?.userProfile?.lastName}`}
                    </span>
                  </span>
                  <span className='text-black card-label fs-5 mb-1'>
                    {/* Speciality.-{' '} */}
                    <span className='fw-bold'>
                      {userDataObj?.userProfile?.userTechDetails?.specialty}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className='p-2 py-6'>
            <div className='d-flex flex-wrap mx-5 flex-column'>
              <div className='d-flex flex-row justify-content-between'>
                <div className='d-flex flex-row justify-content-start w-50 h-25px'>
                  <span className='text-black card-label fs-5 mb-1'>
                    Email-{' '}
                    <span className='fw-bold'>{businessData?.businessProfile?.businessEmail}</span>
                  </span>
                </div>
              </div>

              <div className='d-flex flex-row justify-content-between'>
                <div className='d-flex flex-row justify-content-start w-50 h-25px'>
                  <span className='text-black card-label fs-5 mb-1'>
                    Street- <span className='fw-bold'>{businessData?.businessAddress?.street}</span>
                  </span>
                </div>
                <div className='d-flex flex-row justify-content-start w-50 h-25px'>
                  <span className='text-black card-label fs-5 mb-1'>
                    City- <span className='fw-bold'>{businessData?.businessAddress?.city}</span>
                  </span>
                </div>
              </div>
              <div className='d-flex flex-row justify-content-between'>
                <div className='d-flex flex-row justify-content-start w-50 h-25px'>
                  <span className='text-black card-label fs-5 mb-1'>
                    District-{' '}
                    <span className='fw-bold'>{businessData?.businessAddress?.district}</span>
                  </span>
                </div>
                <div className='d-flex flex-row justify-content-start w-50 h-25px'>
                  <span className='text-black card-label fs-5 mb-1'>
                    State- <span className='fw-bold'>{businessData?.businessAddress?.state}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'insight' && (
        <div className='d-flex flex-column'>
          <div className='d-flex justify-content-between px-8 py-4'>
            <div className='d-flex'>
              {selectedPeriod === 'Daily' && (
                <input
                  type='date'
                  className='form-control'
                  value={moment(selectedDateValue).format('YYYY-MM-DD')}
                  onChange={(e) => setSelectedDateValue(new Date(e.target.value))}
                  style={{width: '150px'}}
                />
              )}
            </div>

            {selectedPeriod === 'Weekly' && (
              <div className='d-flex'>
                <div className='dropdown me-3'>
                  <button
                    className='btn btn-secondary dropdown-toggle'
                    type='button'
                    id='weeklyMonthDropdown'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    {moment(selectedMonthForWeekly).format('MMM YYYY')}
                  </button>
                  <ul className='dropdown-menu' aria-labelledby='weeklyMonthDropdown'>
                    {generateMonthOptions(6).map((option) => (
                      <li key={option.props.value}>
                        <button
                          className='dropdown-item'
                          onClick={() =>
                            handleMonthForWeeklyChange({
                              target: {value: option.props.value},
                            } as React.ChangeEvent<HTMLSelectElement>)
                          }
                        >
                          {option.props.children}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className='dropdown'>
                  <button
                    className='btn btn-secondary dropdown-toggle'
                    type='button'
                    id='weeklyWeekDropdown'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    {selectedWeek
                      ? generateWeekOptions(selectedMonthForWeekly).find(
                          (w) => w.value === selectedWeek
                        )?.label || 'Select Week'
                      : 'Select Week'}
                  </button>
                  <ul className='dropdown-menu' aria-labelledby='weeklyWeekDropdown'>
                    {generateWeekOptions(selectedMonthForWeekly).map((option) => (
                      <li key={option.value}>
                        <button
                          className='dropdown-item'
                          onClick={() =>
                            handleWeekChange({
                              target: {value: option.value},
                            } as React.ChangeEvent<HTMLSelectElement>)
                          }
                        >
                          {option.label}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            {selectedPeriod === 'Monthly' && (
              <div className='dropdown'>
                <button
                  className='btn btn-secondary dropdown-toggle'
                  type='button'
                  id='monthlyDropdown'
                  data-bs-toggle='dropdown'
                  aria-expanded='false'
                >
                  {moment(selectedMonthForMonthly).format('MMM YYYY')}
                </button>
                <ul className='dropdown-menu' aria-labelledby='monthlyDropdown'>
                  {generateMonthOptions(6).map((option) => (
                    <li key={option.props.value}>
                      <button
                        className='dropdown-item'
                        onClick={() =>
                          handleMonthForMonthlyChange({
                            target: {value: option.props.value},
                          } as React.ChangeEvent<HTMLSelectElement>)
                        }
                      >
                        {option.props.children}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          <span className='card-label fw-normal fs-3 mb-1 px-8'>{heading}</span>
          <div className='d-flex flex-direction-row flex-wrap card-header border-1  justify-content-between '>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold' style={{color: 'red'}}>
                  {pharmaInsights?.expirySoon || 0}
                </span>
                <span>Expiry Soon</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold' style={{color: 'red'}}>
                  {pharmaInsights?.expiredMedicine || 0}
                </span>
                <span>Expired Medicine</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.medicineInStock || 0}</span>
                <span>Medicine In Stock</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.orderRestock || 0}</span>
                <span>Order Restock</span>
              </div>
            </div>
          </div>
          <span className='card-label fw-normal fs-3 mb-1 px-8'>My Pharmacy </span>
          <div className='d-flex flex-direction-row flex-wrap card-header  justify-content-between '>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.doctorSaleOrderCreated || 0}</span>
                <span>Doctor Orders</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>
                  {pharmaInsights?.doctorSaleOrderCompleted || 0}
                </span>
                <span>Doctor Orders Completed</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.totalSaleOrder || 0}</span>
                <span>Total Sale Orders</span>
              </div>
            </div>
          </div>
          <div className='d-flex flex-direction-row flex-wrap card-header  justify-content-between '>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.totalSaleOrderCompleted || 0}</span>
                <span>Sales Order Completed</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.saleOrderRevenue || 0}</span>
                <span>Sales Order Revenue</span>
              </div>
            </div>
            <div className=' bg-light my-6 col p-2 m-5 rounded'>
              <div className='d-flex flex-column text-center'>
                <span className='fs-5 fw-bold'>{pharmaInsights?.totalSaleOrderReturned || 0}</span>
                <span>Total Orders Returned</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export {PharmaDetails}
